// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================
   Header Layout
   ===================== */

.scl--style-header {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    box-sizing: border-box;
    transition:
        background 0.25s ease,
        backdrop-filter 0.25s ease,
        -webkit-backdrop-filter 0.25s ease;
}

.scl--style-header.is-scrolled {
    backdrop-filter: blur(10px);
    background: #00000026;
}

.scl--cnt-sty-head-box{
    width: 100%;
    max-width: var(--global-desktop-width-resp);
    height: 74px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: var(--global-desktop-padding-left);
    padding-right:  var(--global-desktop-padding-right);
    padding-top: var(--header-padding-top, 0);
    padding-bottom: var(--header-padding-bottom, 0);
}

/* =====================
   Logo
   ===================== */

.scl--style-logo-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.scl--style-logo-icon {
    object-fit: cover;
}

.scl--style-logo-text {
    font-family: var(--header-brand-name-text-font-family, var(--font-manrope-regular));
    font-weight: var(--header-brand-name-text-font-weight, 600);
    font-size: var(--header-brand-name-text-font-size, 26px);
    line-height: 1;
    letter-spacing: 0.02em;
    color: white;
}

/* =====================
   Navigation
   ===================== */

.scl--style-navigation {
    display: flex;
    align-items: center;
    gap: 48px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.scl--style-nav-item {
    font-family: var(--primary-font);
    font-weight: var(--header-navigation-text-font-weight, 400);
    font-size: var(--header-navigation-text-font-size, 16px);
    line-height: 24px;
    color: var(--header-navigation-text-font-color, #7d8187);
    cursor: pointer;
    transition: color 0.2s ease;
    white-space: nowrap;
}

.scl--style-nav-item:hover {
    color: #ffffff;
}

.scl--style-nav-item.scl--style-active {
    color: #ffffff;
}

/* =====================
   Contact Button
   ===================== */

.scl--style-contact-button {
    position: relative;
    height:  44px;
    min-width: 155px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: rgba(195, 75, 75, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 30px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    box-shadow:
        0 1px 2px rgba(0, 0, 0, 0.3),
        inset 0 0 0 1px rgba(255, 255, 255, 0.04);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
}

.scl--style-contact-button.active{
    background-color: rgba(195, 75, 75, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.scl--style-contact-button:hover{
    background: rgba(222, 102, 102, 0.5);
    border: 1px solid rgba(255, 255, 255, 1);
}

.scl--style-contact-button:active{
    background: rgba(222, 102, 102, 0.5);
    border: 1px solid rgba(255, 255, 255, 1);
}

.scl--style-contact-button.active .scl--style-button-text{
    color:  #ffffff;
}

.scl--style-button-text {
    font-family: var(--primary-font);
    font-weight: normal;
    font-size: 20px;
    color: #ffffffcc;
    white-space: nowrap;
    transition: all 0.3s;
}

.scl--style-contact-button:hover .scl--style-button-text {
    color:  #ffffff;
}

.scl--dd-menu-hea-stl-cont{
    position: relative;
}

.scl--dmhsc-ico-stl-bo{
    width: 28px;
    height: 28px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
}

.scl--dmhsc-ico-stl-bo button{
    width: 100%;
    height: 100%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-radius: 50%;
}

.scl--hdd-cont-stl-bo {
  position: fixed;
  left: 0;
  top: 52px;
  width: 100%;
  height: 100vh;

  background-color: #000; 
  transform: translateY(-12px);
  opacity: 0;
  pointer-events: none;

  transition:
    transform 0.28s ease,
    opacity 0.28s ease;
}

.scl--hdd-cont-stl-bo.is-open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.scl--hdd-cont-stl-bo.is-closed {
  transform: translateY(-12px);
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/header/css/header.css"],"names":[],"mappings":"AAAA;;0BAE0B;;AAE1B;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,OAAO;IACP,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB;;;0CAGsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gDAAgD;IAChD,mDAAmD;IACnD,yCAAyC;IACzC,+CAA+C;AACnD;;AAEA;;0BAE0B;;AAE1B;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mFAAmF;IACnF,2DAA2D;IAC3D,wDAAwD;IACxD,cAAc;IACd,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;0BAE0B;;AAE1B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,2DAA2D;IAC3D,wDAAwD;IACxD,iBAAiB;IACjB,wDAAwD;IACxD,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;0BAE0B;;AAE1B;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,2CAA2C;IAC3C,mBAAmB;IACnB,2BAA2B;IAC3B,mCAAmC;IACnC;;iDAE6C;IAC7C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;;EAEb,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;;EAEpB;;sBAEoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* =====================\n   Header Layout\n   ===================== */\n\n.scl--style-header {\n    width: 100%;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 1000;\n    box-sizing: border-box;\n    transition:\n        background 0.25s ease,\n        backdrop-filter 0.25s ease,\n        -webkit-backdrop-filter 0.25s ease;\n}\n\n.scl--style-header.is-scrolled {\n    backdrop-filter: blur(10px);\n    background: #00000026;\n}\n\n.scl--cnt-sty-head-box{\n    width: 100%;\n    max-width: var(--global-desktop-width-resp);\n    height: 74px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: var(--global-desktop-padding-left);\n    padding-right:  var(--global-desktop-padding-right);\n    padding-top: var(--header-padding-top, 0);\n    padding-bottom: var(--header-padding-bottom, 0);\n}\n\n/* =====================\n   Logo\n   ===================== */\n\n.scl--style-logo-link {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.scl--style-logo-icon {\n    object-fit: cover;\n}\n\n.scl--style-logo-text {\n    font-family: var(--header-brand-name-text-font-family, var(--font-manrope-regular));\n    font-weight: var(--header-brand-name-text-font-weight, 600);\n    font-size: var(--header-brand-name-text-font-size, 26px);\n    line-height: 1;\n    letter-spacing: 0.02em;\n    color: white;\n}\n\n/* =====================\n   Navigation\n   ===================== */\n\n.scl--style-navigation {\n    display: flex;\n    align-items: center;\n    gap: 48px;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.scl--style-nav-item {\n    font-family: var(--primary-font);\n    font-weight: var(--header-navigation-text-font-weight, 400);\n    font-size: var(--header-navigation-text-font-size, 16px);\n    line-height: 24px;\n    color: var(--header-navigation-text-font-color, #7d8187);\n    cursor: pointer;\n    transition: color 0.2s ease;\n    white-space: nowrap;\n}\n\n.scl--style-nav-item:hover {\n    color: #ffffff;\n}\n\n.scl--style-nav-item.scl--style-active {\n    color: #ffffff;\n}\n\n/* =====================\n   Contact Button\n   ===================== */\n\n.scl--style-contact-button {\n    position: relative;\n    height:  44px;\n    min-width: 155px;\n    padding-left: 20px;\n    padding-right: 20px;\n    background-color: rgba(195, 75, 75, 0.3);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 30px;\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    box-shadow:\n        0 1px 2px rgba(0, 0, 0, 0.3),\n        inset 0 0 0 1px rgba(255, 255, 255, 0.04);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s;\n}\n\n.scl--style-contact-button.active{\n    background-color: rgba(195, 75, 75, 0.3);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scl--style-contact-button:hover{\n    background: rgba(222, 102, 102, 0.5);\n    border: 1px solid rgba(255, 255, 255, 1);\n}\n\n.scl--style-contact-button:active{\n    background: rgba(222, 102, 102, 0.5);\n    border: 1px solid rgba(255, 255, 255, 1);\n}\n\n.scl--style-contact-button.active .scl--style-button-text{\n    color:  #ffffff;\n}\n\n.scl--style-button-text {\n    font-family: var(--primary-font);\n    font-weight: normal;\n    font-size: 20px;\n    color: #ffffffcc;\n    white-space: nowrap;\n    transition: all 0.3s;\n}\n\n.scl--style-contact-button:hover .scl--style-button-text {\n    color:  #ffffff;\n}\n\n.scl--dd-menu-hea-stl-cont{\n    position: relative;\n}\n\n.scl--dmhsc-ico-stl-bo{\n    width: 28px;\n    height: 28px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-radius: 50%;\n}\n\n.scl--dmhsc-ico-stl-bo button{\n    width: 100%;\n    height: 100%;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    border-radius: 50%;\n}\n\n.scl--hdd-cont-stl-bo {\n  position: fixed;\n  left: 0;\n  top: 52px;\n  width: 100%;\n  height: 100vh;\n\n  background-color: #000; \n  transform: translateY(-12px);\n  opacity: 0;\n  pointer-events: none;\n\n  transition:\n    transform 0.28s ease,\n    opacity 0.28s ease;\n}\n\n.scl--hdd-cont-stl-bo.is-open {\n  transform: translateY(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.scl--hdd-cont-stl-bo.is-closed {\n  transform: translateY(-12px);\n  opacity: 0;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
